export { reviewsLandingData } from './reviewsLandingData';
